import { useMemo } from 'react';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';

import rootReducer from '../store/rootReducer';

export let store;
export const sagaMiddleware = createSagaMiddleware();

const Store = ({ children }) => {
  const instance = useMemo(() => {
    const middleware = [sagaMiddleware];
    const enhancers = [applyMiddleware(...middleware)];
    const storeInstance = createStore(rootReducer, composeWithDevTools(...enhancers));
    store = storeInstance;
    return store;
  }, []);

  return <Provider store={instance}>{children}</Provider>;
};

export default Store;
